import HeaderComponent from './header-component';

/***
 * The main header for the site. Contains some buttons (Admin Panel, Logout, etc.) that
 * conditionally display.
 */
const header = angular
    .module('FacilityData.Common.Header', [])
    .component('siteHeader', HeaderComponent)
    .name;

export default header;


// WEBPACK FOOTER //
// ./app/common/header/header.js